import {
    FETCH_MULTIPLE_USER_SOCIAL_PROFILE_IMAGE_DONE,
    FETCH_MULTIPLE_USER_SOCIAL_PROFILE_IMAGE_START,
    FETCH_USER_SOCIAL_PROFILE_IMAGE_VIEWER,
    FETCH_USER_SOCIAL_PROFILE_IMAGE_VIEWER_DONE,
    REMOVE_VIEWER_SOCIAL_PROFILE_IMAGE,
    REMOVE_VIEWER_SOCIAL_PROFILE_IMAGE_DONE
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    viewer: null,
    fetching: false,
    error: false,
    profileImageDtoMap: {},
    /**
     * @type {number[]|string[]}
     * list of fetching userId
     * */
    profileImageDtoFetchingList: [],
    profileImageDtoFetchedTs: {},
    removingProfile: false
};

/** selectors */

const selectUserSocialProfileImageReducer = (state) => {
    return state.userSocialProfileImageReducer;
};

export const selectUserSocialProfileImageViewer = (state) => {
    const reducer = selectUserSocialProfileImageReducer(state);
    return reducer.viewer;
};

export const selectUserSocialProfileImageViewerFetching = (state) => {
    const reducer = selectUserSocialProfileImageReducer(state);
    return reducer.fetching;
};

export const selectUserSocialProfileImageViewerError = (state) => {
    const reducer = selectUserSocialProfileImageReducer(state);
    return reducer.error;
};

export const selectProfileImageDtoMapState = (state) => {
    const reducer = selectUserSocialProfileImageReducer(state);
    return reducer.profileImageDtoMap;
};

export const selectProfileImageDtoOfUserId = (state, userId) => {
    const profileImageDtoMap = selectProfileImageDtoMapState(state);
    return profileImageDtoMap[userId];
};

export const selectProfileImageDtoMapOfUserIdList = (state, userIdList) => {
    if (!Array.isArray(userIdList)) {
        return {};
    }
    const profileImageDtoMap = selectProfileImageDtoMapState(state);
    return userIdList.reduce((acc, userId) => {
        if (!profileImageDtoMap[userId]) {
            return acc;
        }
        acc[userId] = { ...profileImageDtoMap[userId] };
        return acc;
    }, {});
};

export const selectProfileImageDtoFetchingList = (state) => {
    const reducer = selectUserSocialProfileImageReducer(state);
    return reducer.profileImageDtoFetchingList;
};

export const selectProfileImageDtoFetchedTsState = (state) => {
    const reducer = selectUserSocialProfileImageReducer(state);
    return reducer.profileImageDtoFetchedTs;
};

export const selectProfileImageRemovingProfile = (state) => {
    const reducer = selectUserSocialProfileImageReducer(state);
    return reducer.removingProfile;
};

/** handlers */
function handleFetchUserSocialProfileImageViewer(state) {
    return {
        ...state,
        fetching: true,
        error: false
    };
}

function handleFetchUserSocialProfileImageViewerDone(state, action) {
    return {
        ...state,
        viewer: action.data,
        fetching: false,
        error: action.error
    };
}

function handleFetchMultipleUserSocialProfileImageStart(state, action) {
    if (!action.userIds || !action.userIds.length) {
        return state;
    }
    const newFetchingList = [...state.profileImageDtoFetchingList, ...action.userIds];
    return {
        ...state,
        profileImageDtoFetchingList: newFetchingList
    };
}

function handleFetchMultipleUserSocialProfileImageDone(state, action) {
    if (action.error || !action.data) {
        return state;
    }
    const newFetchingSet = new Set();
    state.profileImageDtoFetchingList.forEach((item) => {
        newFetchingSet.add(item);
    });
    const ts = Date.now();
    const newFetchedTs = {};
    Object.values(action.data).forEach((item) => {
        newFetchedTs[item.profileId] = ts;
        newFetchingSet.delete(item.profileId);
    });
    const newFetchingList = [...newFetchingSet];
    return {
        ...state,
        profileImageDtoMap: {
            ...state.profileImageDtoMap,
            ...action.data
        },
        profileImageDtoFetchedTs: {
            ...state.profileImageDtoFetchedTs,
            ...newFetchedTs
        },
        profileImageDtoFetchingList: newFetchingList
    };
}

function handleRemoveUserSocialProfileImage(state) {
    return {
        ...state,
        removingProfile: true
    };
}

function handleRemoveUserSocialProfileImageDone(state) {
    return {
        ...state,
        removingProfile: false
    };
}

const handlers = {
    [FETCH_USER_SOCIAL_PROFILE_IMAGE_VIEWER]: handleFetchUserSocialProfileImageViewer,
    [FETCH_USER_SOCIAL_PROFILE_IMAGE_VIEWER_DONE]: handleFetchUserSocialProfileImageViewerDone,
    [FETCH_MULTIPLE_USER_SOCIAL_PROFILE_IMAGE_START]: handleFetchMultipleUserSocialProfileImageStart,
    [FETCH_MULTIPLE_USER_SOCIAL_PROFILE_IMAGE_DONE]: handleFetchMultipleUserSocialProfileImageDone,
    [REMOVE_VIEWER_SOCIAL_PROFILE_IMAGE]: handleRemoveUserSocialProfileImage,
    [REMOVE_VIEWER_SOCIAL_PROFILE_IMAGE_DONE]: handleRemoveUserSocialProfileImageDone
};

export default function userSocialProfileImageReducer(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];
    if (!handler) {
        return state;
    }
    return handler(state, action);
}
